import { render, staticRenderFns } from "./OrdersDashboardSection.vue?vue&type=template&id=05f856d7&scoped=true&"
import script from "./OrdersDashboardSection.vue?vue&type=script&lang=js&"
export * from "./OrdersDashboardSection.vue?vue&type=script&lang=js&"
import style0 from "./OrdersDashboardSection.vue?vue&type=style&index=0&id=05f856d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f856d7",
  null
  
)

export default component.exports